<div class="flex flex-col gap-2">
  <div class="flex items-center justify-between gap-2">
    <p class="font-medium" [class.text-on-surface-variant]="disabled()">
      {{ fieldName() }}
      @if (isRequired()) {
        <span>*</span>
      }
    </p>
    <div class="flex items-center gap-2 shrink-0">
      @if (hint(); as hint) {
        <app-hint-icon [text]="hint" />
      }
      <ng-content select="[fieldToggle]"></ng-content>
    </div>
  </div>
  <div
    class="flex flex-col"
    [class.opacity-50]="disabled()"
    [class.pointer-events-none]="disabled()"
  >
    <ng-content></ng-content>
  </div>
</div>
